<div class="playbook-actions-cell">
  @for (action of visibleActions; track $index) {
    <div class="action-item">{{ action }}</div>
  }
  @if (hasMoreActions) {
    <div
      class="more-actions"
      [matTooltip]="tooltipText"
      matTooltipClass="playbook-actions-tooltip"
      [matTooltipPosition]="'above'"
    >
      +{{ remainingCount }}
    </div>
  }
</div>
